import Vue from 'vue'
import Router from 'vue-router'
import home from '@/page/sys/home'
import store from '@/page/sys/storeHome'

Vue.use(Router)

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: home,
            children: [{
                path: '/', // 首页
                component: (resolve) => require(['@/page/main/firstPage'], resolve)
            }, {
                path: 'firstPage', // 首页
                component: (resolve) => require(['@/page/main/firstPage'], resolve)
            }, {
                path: '/blueWhale',
                name: 'blueWhale',
                component: (resolve) => require(['@/page/main/products/blueWhale'], resolve)
            }, {
                path: '/bus',
                name: 'bus',
                component: (resolve) => require(['@/page/main/products/bus'], resolve)
            }, {
                path: '/sweeper',
                name: 'sweeper',
                component: (resolve) => require(['@/page/main/products/sweeper'], resolve)
            }, {
                path: '/remoteDriving',
                name: 'remoteDriving',
                component: (resolve) => require(['@/page/main/products/remoteDriving'], resolve)
            }, {
                path: '/materialFlow',
                name: 'materialFlow',
                component: (resolve) => require(['@/page/main/products/materialFlow'], resolve)
            }, {
                path: 'aboutUs', // 关于我们
                component: (resolve) => require(['@/page/main/aboutUs'], resolve)
            }]
        }, {
            path: '/store',
            name: 'store',
            component: store,
            children: [{
                path: 'firstPage', // 备件商城
                component: (resolve) => require(['@/page/store/firstPage'], resolve)
            }, {
                path: 'productDetail', // 商品详情
                component: (resolve) => require(['@/page/store/productDetail'], resolve)
            }, {
                path: 'shopping', // 我的购物车
                component: (resolve) => require(['@/page/store/shopping'], resolve)
            }, {
                path: 'order', // 我的订单
                component: (resolve) => require(['@/page/store/order'], resolve)
            }, {
                path: 'pay', // 确认支付
                component: (resolve) => require(['@/page/store/pay'], resolve)
            }, {
                path: 'paySuccess', // 支付成功页
                component: (resolve) => require(['@/page/store/paySuccess'], resolve)
            }, {
                path: 'my', // 我的
                component: (resolve) => require(['@/page/store/my'], resolve)
            }, {
                path: 'address', // 地址管理
                component: (resolve) => require(['@/page/store/address'], resolve)
            }, {
                path: 'myCollect', // 我的收藏
                component: (resolve) => require(['@/page/store/myCollect'], resolve)
            }, {
                path: 'orderDetail', // 订单详情
                component: (resolve) => require(['@/page/store/orderDetail'], resolve)
            }]
        }
    ]
})

router.afterEach((to, from, next) => {
    // 不论从哪里点击跳转，均会到顶部
    window.scrollTo(0, 0);
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js